import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { USER_ROLES } from '@shared/index';
import { EncryptionStorageService } from './encryption-storage.service';

export const groupUserGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authGuardService: AuthService = inject(AuthService);
  const encryptStorage: EncryptionStorageService = inject(EncryptionStorageService);
  const roleName = encryptStorage.getItem('roleName')
  if (authGuardService.isLoggedIn() && (roleName === USER_ROLES.GROUP_USER)) {
    return true;

  } router.navigate(['login'])
    return false
};
